export default "__VITE_ASSET__Bfc3VjPS__"